var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H26C31.5228 0 36 4.47715 36 10V26C36 31.5228 31.5228 36 26 36H10C4.47715 36 0 31.5228 0 26V10Z",
    fill: "#F0FDF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 18H23.64C23.3122 17.9993 22.9932 18.106 22.7318 18.3037C22.4704 18.5015 22.281 18.7794 22.1925 19.095L20.43 25.365C20.4186 25.4039 20.395 25.4382 20.3625 25.4625C20.33 25.4868 20.2906 25.5 20.25 25.5C20.2094 25.5 20.17 25.4868 20.1375 25.4625C20.105 25.4382 20.0814 25.4039 20.07 25.365L15.93 10.635C15.9186 10.5961 15.895 10.5618 15.8625 10.5375C15.83 10.5132 15.7906 10.5 15.75 10.5C15.7094 10.5 15.67 10.5132 15.6375 10.5375C15.605 10.5618 15.5814 10.5961 15.57 10.635L13.8075 16.905C13.7193 17.2194 13.531 17.4964 13.2711 17.694C13.0113 17.8916 12.694 17.9991 12.3675 18H10.5",
    stroke: "#22C55E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.2e174a46cfbbafd539f3d3ab58482c8d.svg";
export { ForwardRef as ReactComponent };